import React from "react";

const NumberCell = ({ value }) => {
  return <span>{value}</span>;
};

export default NumberCell;
